import { render, staticRenderFns } from "./Obijime.vue?vue&type=template&id=1b06049d&"
import script from "./Obijime.vue?vue&type=script&lang=js&"
export * from "./Obijime.vue?vue&type=script&lang=js&"
import style0 from "./Obijime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports